"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var NavigationMenu_1 = __importDefault(require("./NavigationMenu"));
exports.default = NavigationMenu_1.default;
